<template>
  <div id="comments" class="img-container">
    <div class="title-wrapper">
      <div class="section-title">
        <i class="anyteachicon anyteach-daipingjia" />评价
      </div>
      <div :class="{ hidden: isScrolled }" class="line-wrapper">
        <span>向右滑动查看更多</span>
        <i class="anyteachicon anyteach-arrow-right" />
      </div>
    </div>
    <div class="img-wrapper" @scroll="onScroll">
      <img v-for="(item, key) in images" :key="key" :src="item" />
    </div>
  </div>
</template>

<script>

export default {
  name: "Comments",
  props: {
    images: {
      type: Array,
      default: function () {
        return []
      }
    },
  },
  data() {
    return {
      isScrolled: false,
    }
  },
  methods: {
    onScroll() {
      if (!this.isScrolled) {
        this.isScrolled = true
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../../../live/about/style.scss";
@import "../style.scss";

.img-container {
  position: relative;
}
#comments {
  padding: 15px 0 0 0;
  .img-wrapper {
    width: 100%;
    padding: 15px 0 20px 0;
    white-space: nowrap;
    overflow-x: scroll;
    overflow-y: hidden;
    img {
      vertical-align: top;
      width: 50%;
      height: auto;
      margin: 0 0 0 15px;
      box-shadow: 0 0 20px -5px #cacaca;
      border: 1px solid #eee;
      &:first-child {
        margin-left: 5%;
      }
      &:last-child {
        margin-right: 5%;
      }
    }
  }
  .title-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    width: 90%;
    margin: 0 auto;
  }
  .line-wrapper {
    font-size: 0.8rem;
    font-weight: 400;
    padding-right: 20px;
    i {
      animation: shake 2s infinite cubic-bezier(0.5, 0, 0.5, 1);
      margin-left: 5px;
      position: absolute;
    }
    @keyframes shake {
      0%,
      5% {
        transform: translate(-5px);
      }
      45%,
      55% {
        transform: translate(5px);
      }
      95%,
      100% {
        transform: translate(-5px);
      }
    }
  }
  .hidden {
    transition: opacity 0.5s cubic-bezier(0.5, 0, 0.5, 1);
    opacity: 0;
  }
}

@media only screen and (min-width: 600px) {
  #comments {
    .img-wrapper {
      padding-top: 20px;
      img {
        width: 40%;
      }
    }
    .line-wrapper {
      font-size: 1rem;
    }
  }
}
</style>
